import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { fetchPreorderDetails } from '../../../../actions/preorder/preorderDetail'
import { PreorderDetails } from '..'
import { AppState } from '../../../../reducers'
import { PreorderDetailListState } from '../../../../reducers/preorder/preorderDetailList'
import { useTranslation } from 'react-i18next'
import { Paper, Box, Typography, Button, Stack, Tooltip, IconButton, CircularProgress } from '@mui/material';
import { AttachFile, FileDownloadOutlined, KeyboardReturnOutlined /*, LoopOutlined */ } from '@mui/icons-material';
import { formattedCurrency } from '../../../../utils/StringUtils'
import { useThemeContext } from '../../../../theme/ThemeContext'
import { statusPreorderNameTranslated } from '../../../Utils/CommonConst'
import { SessionState } from '../../../../reducers/auth/session'
//import { fetchPendingPreorder } from '../../../../actions/preorder/preorder'
//import Preorder from '../../../../models/Preorder'
import { getToken } from '../../../../utils/fetchApi'
import { fetchPreorder } from '../../../../actions/preorder/preorder'
import { PreorderDataState } from '../../../../reducers/preorder/preorderData'
import Preorder from '../../../../models/Preorder'
import { downloadPreorderFile } from '../../../../actions/preorder/preorderDownloadFile'
import moment from 'moment'

interface Props {
  preorderDetail: PreorderDetailListState
  preorderData: PreorderDataState
  session: SessionState
}

const PreorderDetail: React.FC<Props> = ({ preorderDetail, preorderData, session }) => {
  const dispatch = useDispatch()
  const params = useParams<{ preorderId: string, clientId?: string }>()
  const history = useHistory()
  //const [pendingPreorder, setPendingPreorder] = useState<number>(0)
  const [currentPreorder, setCurrentPreorder] = useState<Preorder | undefined>(undefined)
  const [downloading, setDownloading] = useState<string>('')
  const { t } = useTranslation(['preorder', 'others'])
  const { theme } = useThemeContext()

  useEffect(() => {
    dispatch(fetchPreorderDetails(params.preorderId, undefined, history.location.search))
    dispatch(fetchPreorder(params.preorderId, (preorder: Preorder) =>
      setCurrentPreorder(preorder)))
  }, [dispatch, params.preorderId, params.clientId, history.location.search])

  const downloadFilePreorder = async (preorder: Preorder, fileId: string, fileName: string) => {
    if (preorder.attachedFileOnHold && preorder.id) {
      try {
        setDownloading(`${preorder.id}${fileId}`)
        await dispatch(downloadPreorderFile(preorder.id, fileId,
          (file: any) => {

            const url = URL.createObjectURL(new Blob([file], { type: 'application/pdf' }))
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
              'download',
              fileName ? fileName : `Retencion-Carrito-${preorder.id}.pdf`
            );
            document.body.appendChild(link);
            // Start download
            link.click();

            URL.revokeObjectURL(url);
          }))
        setDownloading('')
      }
      catch {
      }
    }
  }

  const HeaderDetail: React.FC = () => {

    return (
      <Paper elevation={2} sx={{ margin: "10px", padding: "2px 2px 2px 2px", bgcolor: theme.palette.success.main }}>
        <Paper elevation={2}
          style={{
            padding: "15px 15px 15px 15px", display: "flex", flexDirection: "column",
            textAlign: "justify", justifyContent: "space-around",
            borderRadius: "4px", margin: "4px"
          }}>
          {preorderDetail.preorderDetail && preorderDetail.preorderDetail.length > 0 &&
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('number')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{preorderDetail.preorderDetail[0].preorderId}</Typography>
              </Box>
              {preorderDetail.preorderDetail[0].preorder && preorderDetail.preorderDetail[0].preorder.prepaymentId &&
                <Box display="flex" alignItems="center">
                  <Typography fontWeight="bold" variant="h6">{t('prepaymentId')}:&nbsp;&nbsp;</Typography>
                  <Typography variant="h6">&nbsp;&nbsp;{preorderDetail.preorderDetail[0].preorder.prepaymentId}</Typography>
                </Box>
              }
              {preorderDetail.preorderDetail[0].preorder &&
                <Box display="flex" alignItems="center">
                  <Typography fontWeight="bold" variant="h6">{t('status')}:&nbsp;&nbsp;</Typography>
                  <Typography variant="h6">&nbsp;&nbsp;{statusPreorderNameTranslated(preorderDetail.preorderDetail[0].preorder.status!, t)}</Typography>
                </Box>
              }
              {preorderDetail.preorderDetail[0].preorder &&
                <Box display="flex" alignItems="center">
                  <Typography fontWeight="bold" variant="h6">{t('subtotal')}:&nbsp;&nbsp;</Typography>
                  <Typography variant="h6">
                    {currentPreorder && currentPreorder.detail && formattedCurrency(currentPreorder.detail.reduce((amount, det) => amount + Number(det.amount), 0))}
                    {/*preorderDetail.preorderDetail && formattedCurrency(preorderDetail.preorderDetail.reduce((amount, det) => amount + Number(det.amount), 0))*/}
                  </Typography>
                </Box>
              }
            </Box>}
          {preorderDetail.preorderDetail && preorderDetail.preorderDetail.length > 0 && preorderDetail.preorderDetail[0].preorder &&
            <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" >
              {preorderDetail.preorderDetail[0].preorder && preorderDetail.preorderDetail[0].preorder.purchaseOrder &&
                <Box display="flex" justifyContent="flex-start" alignItems="center">
                  <Typography fontWeight="bold" variant="h6">{t('purchaseOrder')}:&nbsp;&nbsp;</Typography>
                  <Typography variant="body1">{preorderDetail.preorderDetail[0].preorder.purchaseOrder}</Typography>
                </Box>}
              {preorderDetail.preorderDetail[0].preorder && preorderDetail.preorderDetail[0].preorder.dl_address &&
                <Box display="flex" justifyContent="flex-start" alignItems="center">
                  <Typography fontWeight="bold" variant="h6">{t('delivery')}:&nbsp;&nbsp;</Typography>
                  <Typography variant="body1">
                    {preorderDetail.preorderDetail[0].preorder.dl_address}
                    {preorderDetail.preorderDetail[0].preorder.dl_locality ? ` - ${preorderDetail.preorderDetail[0].preorder.dl_locality}` : ''}
                    {preorderDetail.preorderDetail[0].preorder.dl_phone ? ` - ${preorderDetail.preorderDetail[0].preorder.dl_phone}` : ''}
                    {preorderDetail.preorderDetail[0].preorder.dl_openingHours ? ` - ${preorderDetail.preorderDetail[0].preorder.dl_openingHours}` : ''}
                  </Typography>
                </Box>}
            </Box>}
          {preorderDetail.preorderDetail && preorderDetail.preorderDetail.length > 0 && preorderDetail.preorderDetail[0].preorder && preorderDetail.preorderDetail[0].preorder.priceListId &&
            <Box display="flex" justifyContent="flex-start" alignItems="center">
              <Typography fontWeight="bold" variant="h6">{t('listPrice')}:&nbsp;&nbsp;</Typography>
              <Typography variant="body1">
                {preorderDetail.preorderDetail[0].preorder.priceListId}
              </Typography>
            </Box>}
          {preorderDetail.preorderDetail && preorderDetail.preorderDetail.length > 0 && preorderDetail.preorderDetail[0].preorder && preorderDetail.preorderDetail[0].preorder.remarks &&
            <Box display="flex" justifyContent="flex-start" alignItems="center">
              <Typography fontWeight="bold" variant="h6">{t('remarksTitle')}:&nbsp;&nbsp;</Typography>
              <Typography variant="body1">
                {preorderDetail.preorderDetail[0].preorder.remarks}
              </Typography>
            </Box>}
          {preorderDetail.preorderDetail && preorderDetail.preorderDetail.length > 0 &&
            preorderDetail.preorderDetail[0].preorder &&
            (preorderDetail.preorderDetail[0].preorder.holdedRemarks || preorderDetail.preorderDetail[0].preorder.attachedFileOnHold) &&
            <Box display="flex" justifyContent="flex-start" alignItems="baseline">
              <Typography fontWeight="bold" sx={{ whiteSpace: 'nowrap', verticalAlign: 'top' }} variant="h6">{t('holdedRemarksTitle')}:&nbsp;&nbsp;</Typography>
              <Typography variant="body1">
                {preorderDetail.preorderDetail[0].preorder.holdedRemarks}
              </Typography>
              {preorderDetail.preorderDetail[0].preorder.attachedFileOnHold &&
                <>
                  <Typography fontWeight="bold" variant="h6">&nbsp;&nbsp;{t('attachedFile')}:&nbsp;&nbsp;</Typography>
                  <Typography variant="body1">{preorderDetail.preorderDetail[0].preorder.fileNameHolded}
                    <Tooltip title={preorderDetail.preorderDetail[0].preorder.fileNameHolded ? preorderDetail.preorderDetail[0].preorder.fileNameHolded : ''}>
                      <IconButton color="secondary"
                        onClick={(e) => {
                          e.stopPropagation(); preorderDetail.preorderDetail && preorderDetail.preorderDetail[0].preorder &&
                            preorderDetail.preorderDetail[0].preorder.attachedFileOnHold && preorderDetail.preorderDetail[0].preorder.fileNameHolded && downloadFilePreorder(preorderDetail.preorderDetail[0].preorder, preorderDetail.preorderDetail[0].preorder.attachedFileOnHold, preorderDetail.preorderDetail[0].preorder.fileNameHolded)
                        }}>
                        {downloading === `${preorderDetail.preorderDetail[0].preorder.id}${preorderDetail.preorderDetail[0].preorder.attachedFileOnHold}` ? <CircularProgress size={15} /> : <AttachFile fontSize="small" />}
                      </IconButton>
                    </Tooltip>
                  </Typography>
                </>}

            </Box>}
          {preorderDetail.preorderDetail && preorderDetail.preorderDetail.length > 0 &&
            preorderDetail.preorderDetail[0].preorder &&
            (preorderDetail.preorderDetail[0].preorder.rejectedRemarks || preorderDetail.preorderDetail[0].preorder.attachedFileOnReject) &&
            <Box display="flex" justifyContent="flex-start" alignItems="baseline">
              <Typography fontWeight="bold" sx={{ whiteSpace: 'nowrap', verticalAlign: 'top' }} variant="h6">{t('rejectedRemarksTitle')}:&nbsp;&nbsp;</Typography>
              <Typography variant="body1">
                {preorderDetail.preorderDetail[0].preorder.rejectedRemarks}
              </Typography>

              {preorderDetail.preorderDetail[0].preorder.attachedFileOnReject &&
                <>
                  <Typography fontWeight="bold" variant="h6">&nbsp;&nbsp;{t('attachedFile')}:&nbsp;&nbsp;</Typography>
                  <Typography variant="body1">{preorderDetail.preorderDetail[0].preorder.fileNameRejected}
                    <Tooltip title={preorderDetail.preorderDetail[0].preorder.fileNameRejected ? preorderDetail.preorderDetail[0].preorder.fileNameRejected : ''}>
                      <IconButton color="secondary"
                        onClick={(e) => {
                          e.stopPropagation(); preorderDetail.preorderDetail && preorderDetail.preorderDetail[0].preorder &&
                            preorderDetail.preorderDetail[0].preorder.attachedFileOnReject && preorderDetail.preorderDetail[0].preorder.fileNameRejected && downloadFilePreorder(preorderDetail.preorderDetail[0].preorder, preorderDetail.preorderDetail[0].preorder.attachedFileOnReject, preorderDetail.preorderDetail[0].preorder.fileNameRejected)
                        }}>
                        {downloading === `${preorderDetail.preorderDetail[0].preorder.id}${preorderDetail.preorderDetail[0].preorder.attachedFileOnReject}` ? <CircularProgress size={15} /> : <AttachFile fontSize="small" />}
                      </IconButton>
                    </Tooltip>
                  </Typography>
                </>}

            </Box>}
            {preorderDetail.preorderDetail && preorderDetail.preorderDetail.length > 0 && preorderDetail.preorderDetail[0].preorder && preorderDetail.preorderDetail[0].preorder.dateUpdated &&
            <Box display="flex" justifyContent="flex-start" alignItems="center">
              <Typography fontWeight="bold" variant="h6">{t('lastUpdate')}:&nbsp;&nbsp;</Typography>
              <Typography variant="body1">
                {moment(preorderDetail.preorderDetail[0].preorder.dateUpdated).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY HH:mm')}
              </Typography>
            </Box>}            
        </Paper>
      </Paper>
    )
  }


  return (
    <Stack style={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(100% - var(--header-height)' }}>
      <HeaderDetail />
      <PreorderDetails
        rows={(preorderDetail.preorderDetail || []).sort((a, b) => a && b ? a.code > b.code ? 1 : -1 : 0)}
        loading={preorderDetail.isFetching && preorderData.isFetching}
        pagination={preorderDetail.pagination || undefined}
      />

      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Button color="secondary" variant="contained" sx={{ textTransform: "none", margin: "10px" }} startIcon={<KeyboardReturnOutlined />} onClick={() => history.goBack()}>{t("back", { ns: 'others' })}</Button>
        {preorderDetail && preorderDetail.preorderDetail && preorderDetail.preorderDetail.length > 0 &&
          preorderDetail.preorderDetail[0].preorder && preorderDetail.preorderDetail[0].preorder.status !== 'P' &&
          preorderDetail.preorderDetail[0].preorder.status !== 'A' &&
          //<Tooltip title={pendingPreorder > 0 ? `${t('errorMakingNewPreorder')}` : `${t('makingNewPreorder')}`}>
          <Tooltip title={t('downloadingPreorder')}>
            <span>
              <Button variant="contained" sx={{ textTransform: "none", margin: "10px" }}
                //disabled={pendingPreorder > 0}
                //startIcon={<LoopOutlined />} 
                startIcon={<FileDownloadOutlined />}
                href={`${process.env.REACT_APP_API_URL}/preorders/download/${preorderDetail.preorderDetail[0].preorderId}?access_token=${getToken()}`} target="_blank">
                {t("downloadPreorder")}
              </Button>
            </span>
          </Tooltip>
        }
      </Box>
    </Stack>
  )
}

const mapStateToProps = (state: AppState) => ({
  preorderDetail: state.preorderDetailList,
  preorderData: state.preorderData,
  session: state.session
})


export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(PreorderDetail);